var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  这是物资管理昂，但是你还没有权限\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }